//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { axiosGet } from '@/api/index.js'
import SymptomMixin from '@/views/mixins/guide/SymptomMixin'

export default {
  name: 'Symptom',
  mixins: [SymptomMixin]
}



// WEBPACK FOOTER //
// ./src/views/guide/vistel/Symptom.vue